import app from "../stores/app";


Date.isLeapYear = function (year) {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
};

Date.getDaysInMonth = function (year, month) {
    return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
};

Date.prototype.isLeapYear = function () {
    return Date.isLeapYear(this.getFullYear());
};

Date.prototype.getDaysInMonth = function () {
    return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
};

Date.prototype.addMonths = function (value) {
    let n = this.getDate();
    this.setDate(1);
    this.setMonth(this.getMonth() + value);
    this.setDate(Math.min(n, this.getDaysInMonth()));
    return this;
};


const getDate = () => {
    let dt = new Date();

    return formatDate(dt);
}

const humanDate = (date) => {
    if (!date) {
        return '';
    }

    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    // const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    // const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

    let dt;
    let today = new Date();

    if (date instanceof Date) {
        dt = date;
    } else {
        dt = new Date(date);
    }

    if (today.getFullYear() + today.getMonth() + today.getDate() == dt.getFullYear() + dt.getMonth() + dt.getDate()) {
        return 'Today';
    }

    if (today.getFullYear() == dt.getFullYear()) {
        return `${dt.getDate()} ${months[dt.getMonth()]}`;
    }

    // return `${days[dt.getDay()]}, ${dt.getDate()} ${months[dt.getMonth()]} ${dt.getFullYear()}`;
    return `${dt.getDate()} ${months[dt.getMonth()]} ${dt.getFullYear()}`;
}


// y-m-d H:i:s
const formatDate = (date, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        // date is string
        // separate date and time
        let [d, t] = date.split(" ");

        let parts = d.split("-");
        if (parts.length < 3) {
            console.log("formatDate: wrong date", date, parts);
            return '';
        }
        if (parts[0].length == 4) { // year comes first
            dt = new Date(date);
        } else {
            dt = new Date(`${parts[2]}-${parts[1]}-${parts[0]}` + (t ? ` ${t}` : ''));
        }
    }

    let dateStr = '';
    for (let i = 0; i < format.length; i++) {
        if (format[i] === 'y') {
            dateStr += dt.getFullYear();
        } else if (format[i] === 'm') {
            dateStr += pad0(dt.getMonth() + 1);
        } else if (format[i] === 'd') {
            dateStr += pad0(dt.getDate());
        } else if (format[i] === 'H') {
            dateStr += pad0(dt.getHours());
        } else if (format[i] === 'i') {
            dateStr += pad0(dt.getMinutes());
        } else if (format[i] === 's') {
            dateStr += pad0(dt.getSeconds());
        } else {
            dateStr += format[i];
        }
    }
    return dateStr;
}

const dateAfter = (date = 'today', days = 1, format = 'y-m-d') => {
    if (!date) {
        return '';
    }

    let dt;

    if (date instanceof Date) {
        // date is date class
        dt = date;
    } else {
        if (date == 'today') {
            dt = new Date();
        } else {
            dt = new Date(date);
        }
    }
    dt.setDate(dt.getDate() + days);
    return formatDate(dt, format);
}

// const setSubscriptionDates = (expire_at) => {
//     let start_at = null;
//     let end_at = null;
//
//     if (!expire_at) {
//         start_at = getDate();
//     } else {
//         start_at = dateAfter(expire_at, 1);
//     }
//
//     end_at = dateAfter(start_at, 364);
//
//     return [start_at, end_at];
// }

const setSubscriptionDates = (expire_year) => {
    let start_year = null;
    let end_year = null;

    if (!expire_year) {
        start_year = formatDate(new Date, 'y');
    } else {
        start_year = ~~expire_year + 1;
    }

    end_year = start_year + 1;

    return [start_year, end_year];
}

const pad0 = x => x.toString().padStart(2, "0");


const copyObject = obj => {
    return JSON.parse(JSON.stringify(obj));
};

const copyObjectData = (src, dst, exact = true) => {
    Object.keys(dst).map(key => {
        if (exact) {
            if (dst[key] != undefined) dst[key] = src[key];
        } else {
            dst[key] = src[key];
        }
    });
}

const copyObjectProperties = (src, dst, properties) => {
    if (!properties) {
        properties = dst;
        dst = {};
    }

    properties.map(item => {
        dst[item] = src[item];
    });

    return dst;
}

const sort = (array, key, descending) => {
    if (descending) {
        return array.sort((a, b) => (a[key] < b[key] ? 1 : -1));
    }

    return array.sort((a, b) => (a[key] > b[key] ? 1 : -1));
}

const setFocusTo = (element_id, delay = 280) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, delay);
    }
}

const setFocusOut = (element_id) => {
    if (!element_id) {
        return;
    }

    let element = document.getElementById(element_id);
    if (element) element.blur();
};

const scrollTo = (element_id, offset = 0) => {
    if (element_id === 'top') {
        window.scrollTo({top: 0, behavior: 'smooth'});
    } else {
        let scrollDiv = document.getElementById(element_id).offsetTop + offset;
        window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
    }
}

const upCaseStr = str => {
    if (!str) {
        return "";
    }
    let arr = [['Ά', 'Α'], ['Έ', 'Ε'], ['Ή', 'Η'], ['Ί', 'Ι'], ['Ϊ', 'Ι'], ['Ό', 'Ο'], ['Ύ', 'Υ'], ['Ϋ', 'Υ'], ['Ώ', 'Ω']];
    str = str.toUpperCase();
    arr.map(chars => {
        str = str.split(chars[0]).join(chars[1]);
    });
    return str;
}

const nl2br = str => {
    return str.split("\n").join("<br>");
}


const memberName = member => {
    return (member.lastname + ' ' + member.firstname).trim();
}

const arrayIndex = (array, term) => {
    if (!array) {
        return -1;
    }

    if (!term) {
        return -1;
    }

    term = upCaseStr(term);

    let matchIndex = -1;
    let index = 0;
    array.map(item => {
        if (matchIndex < 0) {
            let name = upCaseStr(item);
            if (name === term) {
                matchIndex = index;
            }
            if (matchIndex < 0 && name.includes(term)) {
                matchIndex = index;
            }
        }
        index++;
    });

    return matchIndex;
}

const arrayFilter = (array, term) => {
    let result = [];

    if (!array || !term) {
        return result;
    }

    term = upCaseStr(term);
    array.map(item => {
        let name = upCaseStr(item);
        if (name.includes(term)) {
            if (result.indexOf(item) < 0) {
                result.push(item);
            }
        }
    });

    return result;
}

const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
}



export {
    pad0,
    getDate,
    dateAfter,
    humanDate,
    formatDate,
    setSubscriptionDates,
    copyObject,
    copyObjectData,
    copyObjectProperties,
    sort,
    setFocusTo,
    setFocusOut,
    scrollTo,
    upCaseStr,
    nl2br,
    arrayIndex,
    arrayFilter,
    isNumeric,
    memberName,
}